"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryMetadataCreatorsBeet = exports.PrimaryMetadataCreators = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const Creator_1 = require("../types/Creator");
const primaryMetadataCreatorsDiscriminator = [66, 131, 48, 36, 100, 130, 177, 11];
class PrimaryMetadataCreators {
    constructor(creators) {
        this.creators = creators;
    }
    static fromArgs(args) {
        return new PrimaryMetadataCreators(args.creators);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return PrimaryMetadataCreators.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find PrimaryMetadataCreators account at ${address}`);
        }
        return PrimaryMetadataCreators.fromAccountInfo(accountInfo, 0)[0];
    }
    static deserialize(buf, offset = 0) {
        return exports.primaryMetadataCreatorsBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.primaryMetadataCreatorsBeet.serialize({
            accountDiscriminator: primaryMetadataCreatorsDiscriminator,
            ...this,
        });
    }
    static byteSize(args) {
        const instance = PrimaryMetadataCreators.fromArgs(args);
        return exports.primaryMetadataCreatorsBeet.toFixedFromValue({
            accountDiscriminator: primaryMetadataCreatorsDiscriminator,
            ...instance,
        }).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(PrimaryMetadataCreators.byteSize(args), commitment);
    }
    pretty() {
        return {
            creators: this.creators,
        };
    }
}
exports.PrimaryMetadataCreators = PrimaryMetadataCreators;
exports.primaryMetadataCreatorsBeet = new beet.FixableBeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['creators', beet.array(Creator_1.creatorBeet)],
], PrimaryMetadataCreators.fromArgs, 'PrimaryMetadataCreators');
//# sourceMappingURL=PrimaryMetadataCreators.js.map